import { render } from "./HeaderMenu.vue?vue&type=template&id=03644cde&scoped=true"
import script from "./HeaderMenu.vue?vue&type=script&lang=js"
export * from "./HeaderMenu.vue?vue&type=script&lang=js"

import "./HeaderMenu.vue?vue&type=style&index=0&id=03644cde&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03644cde"]])

export default __exports__